// @ts-nocheck
// @ts-ignore
import axios from 'axios';
import { useDispatch } from 'react-redux';

import API_ENDPOINTS from '../../const/ApiEndPoints';
import { loginSuccess, setThemeMode } from '../../store/slices/UserSilcer';

export default function useUser() {
  const dispatch = useDispatch();

  const createUser = (body) => {
    return axios
      .post(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.AUTH.CREATE_USER}`,
        body
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };
  const updateUser = (body, id) => {
    return axios
      .post(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.AUTH.UPDATE_USER}`,
        body,
        { params: { userid: id } }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };
  const suspendUser = (status, id) => {
    return axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.AUTH.SUSPEND_USER}?action=${status}&user_id=${id}`
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const getUserUsageDetails = (id) => {
    return axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.AUTH.ROLE_LINKAGES_UPDATE}`,
        {
          params: { role_id: id },
        }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const replaceAndDeleteUser = (body) => {
    return axios
      .post(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.AUTH.ROLE_LINKAGES_UPDATE}`,
        body
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const getAllUsers = (params = {}, loader) => {
    const hasConfigKeys =
      'loader' in params || 'params' in params || 'headers' in params;
    const axiosConfig = hasConfigKeys ? params : { params };

    if (loader !== undefined) {
      axiosConfig.loader = loader;
    } else if (!('loader' in axiosConfig)) {
      axiosConfig.loader = true;
    }

    return axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.AUTH.GET_ALL_USER}`,
        axiosConfig
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };
  const getUserSetting = () => {
    return axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.AUTH.USER_SETTING}`,
        {
          loader: false,
        }
      )
      .then((resp) => {
        // Setting the theme mode of the user
        dispatch(
          setThemeMode({
            themeMode: resp?.data?.theme_settings?.type || 'light',
          })
        );
        return resp;
      })
      .catch((error) => {
        throw error;
      });
  };

  const updateUserSetting = (body) => {
    return axios
      .post(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.AUTH.USER_SETTING}`,
        body,
        {
          loader: false,
        }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  // The token and headers are set here because we need to call this API before our axios gets initialized and other APIs gets called, so we call this API before login using directly token.
  //  This API is only used for common auth implementation
  const getUserRelatedDetails = (token, orgName) => {
    const headers = {
      ...(token && { Authorization: `Bearer ${token}` }),
      ...(orgName && { org: orgName }),
    };

    return axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.AUTH.USER_DETAIL}`,
        {
          ...(token && orgName
            ? {
                headers: headers,
              }
            : {}),
        }
      )
      .then((res) => {
        dispatch(
          loginSuccess({
            user: res.data.user,
            profile: res.data.profile,
            token: localStorage.getItem('access_token'),
            refresh: localStorage.getItem('refresh_token'),
          })
        );
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };
  return {
    createUser,
    suspendUser,
    getUserUsageDetails,
    replaceAndDeleteUser,
    updateUser,
    getAllUsers,
    getUserSetting,
    updateUserSetting,
    getUserRelatedDetails,
  };
}
